import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLoaderData, useLocation, useParams } from "react-router";

import { ITeamSchedule } from "@src/types/api";

import { selectSelectedLeague } from "@features/leaguemgmt/leagueManagementSlice";

import { useAppSelector } from "@hooks/reduxHooks";

import Games from "@Leagues/components/Team/Games";
import Header from "@Leagues/components/Team/Header";
import Stats from "@Leagues/components/Team/Stats";

const Team = (): React.JSX.Element => {
    const params = useParams();
    const location = useLocation();
    const isOnTeamSchedulePage = /schedule/.test(location.pathname);
    const teamId = parseInt(params.teamId as string);

    const { schedule } = useLoaderData() as {
        schedule: ITeamSchedule;
    };

    const { ageLevel, designation, direction } = schedule;
    const league = useAppSelector(selectSelectedLeague);
    const team = league?.teams?.find(t => t.id === teamId);
    const teamStandingsData = league?.standings
        ? league.standings[teamId]
        : null;

    return isOnTeamSchedulePage ? (
        <Outlet />
    ) : (
        <Container fluid="xs" data-testid="teamContent" className="teamContent">
            <Row>
                <Col>
                    <Header
                        ageLevel={ageLevel}
                        designation={designation}
                        direction={direction}
                        team={team}
                        standingsData={teamStandingsData}
                    />
                    <Stats standingsData={teamStandingsData} />
                    <Games schedule={schedule} teamId={teamId} />
                </Col>
            </Row>
        </Container>
    );
};

export default Team;
